import { render, staticRenderFns } from "./ListProductionTrailers.vue?vue&type=template&id=49341ad2&"
import script from "./ListProductionTrailers.vue?vue&type=script&lang=js&"
export * from "./ListProductionTrailers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports